<div class="table-wrapper" #tableWrapper fxLayoutGap="10px" fxLayout="column">
  <ngx-datatable
    #table [columns]="ngxColumns" [externalPaging]="false" [externalSorting]="false"
    [reorderable]="false" [rows]="addresses" class="material"
    [rowHeight]="'auto'" [headerHeight]="'auto'" [footerHeight]="50" [limit]="5"
    [scrollbarH]="true" [loadingIndicator]="isLoading" [columnMode]="'force'"
  >
  </ngx-datatable>
  <div fxLayout='row' fxLayoutAlign="end end" *ngIf="checkIfAddress()">
    <button type="button" (click)="addAddress(createUpdateRow)" #addButton mat-raised-button color="accent" [disabled]="isEditing || disabledAddButton">
      {{'REGISTRATION.addNewAddressButton' | transloco}}
    </button>
  </div>
</div>


<ng-template #hdrTpl let-column="column" let-sort="sortFn">
  <span (click)="sort()" class="column-name">{{ column.name }}</span>
</ng-template>
<ng-template #addressTypeTpl let-row="row">
  <span style="display: flex;justify-content: flex-start;gap: 5px;">
    {{ row.addressTypeValue | transloco}}
    <mat-icon *ngIf="showWarning(row)" color="warn">
      lock
    </mat-icon>
  </span>
</ng-template>
<ng-template #activityNameTpl let-row="row">
  <span>{{ row.activityName }}</span>
</ng-template>
<ng-template #addressTpl let-row="row">
  <span >{{ row.address }}</span>
</ng-template>
<ng-template #zipCodeTpl let-row="row">
  <span *ngIf="!row.enabled">{{ row.zipCode }}</span>
</ng-template>
<ng-template #cityTpl let-row="row">
  <span *ngIf="!row.enabled">{{ row.city }}</span>
</ng-template>

<ng-template #vatTPL let-row="row">
  <span *ngIf="!row.enabled">{{ row.vat }}</span>
</ng-template>

<ng-template #autocompleteTpl let-row="row">
  <span *ngIf="!row.enabled">{{ row.countryCode }}</span>
</ng-template>
<ng-template #phoneTpl let-row="row">
  <span *ngIf="!row.enabled">{{ row.phone }}</span>
</ng-template>
<ng-template #actions let-row="row">
  <div fxLayout fxLayoutAlign="space-around center" class="rowIconContainer">
    <div *ngIf="!disabledAddButton" style="position: relative;">
      <mat-icon *ngIf="!row.enabled" (click)="editAddressModal(row, createUpdateRow)" style="display:block;">edit</mat-icon>
      <div class="status-loading" *ngIf="loadingEditStatus === row.idAddress">
        <mat-progress-spinner
          class="margin"
          [diameter]="24"
          [mode]="'indeterminate'"
          [color]="'accent'"
          [value]="10"
        >
        </mat-progress-spinner>
      </div>
    </div>
    <div *ngIf="!disabledAddButton" style="position: relative;">
      <mat-icon *ngIf="!row.enabled" (click)="openDeleteRowModal(deleteRowConfirmation, row)" style="display:block;">delete</mat-icon>
      <div class="status-loading" *ngIf="loadingDeleteStatus === row.idAddress">
        <mat-progress-spinner
          class="margin"
          [diameter]="24"
          [mode]="'indeterminate'"
          [color]="'accent'"
          [value]="10"
        >
        </mat-progress-spinner>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #createUpdateRow>
  <mat-card-header>
    <mat-card-title>{{ (isEdit ? 'REGISTRATION.updateNewAddressButton' : 'REGISTRATION.addNewAddressButton') | transloco}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="addressCreateUpdateForm" style="width: 800px;">
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20">
        <div fxLayout="column" fxFlex="49%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.COLUMNS.AddressTypeColumn' | transloco}} *</mat-label>
            <mat-select formControlName="addressType" [disabled]="allowEditCarrierForShipping()">
              <mat-option value="R">
                {{'REGISTRATION.returnTypeValue' | transloco}}
              </mat-option>
              <mat-option value="S">
                {{'REGISTRATION.shipTypeValue' | transloco}}
              </mat-option>
              <mat-option value="I">
                {{'REGISTRATION.invoiceTypeValue' | transloco}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="49%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.ActivityNamePlaceHolder' | transloco}} *</mat-label>
            <input maxlength="40" placeholder='{{"REGISTRATION.ActivityNamePlaceHolder" | transloco}}' matInput type="text"
                   [readonly]="allowEditCarrierForShipping()"
                   name="activityName" formControlName="activityName">
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20" *ngIf="!unlockedGoogleMaps">
        <div fxLayout="column" fxFlex="100%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.AddressPlaceHolder' | transloco}} *</mat-label>
            <input ngx-google-places-autocomplete name="address" [options]="options"
                   [readonly]="allowEditCarrierForShipping()"
                   matInput formControlName="addressTemp" #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)"/>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20" *ngIf="unlockedGoogleMaps">
        <div fxLayout="column" fxFlex="100%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.AddressPlaceHolder' | transloco}} *</mat-label>
            <input [readonly]="allowEditCarrierForShipping()"
                   matInput formControlName="address"/>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20">
        <div fxLayout="column" fxFlex="25%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.CityPlaceHolder' | transloco}}</mat-label>
            <input placeholder='{{"REGISTRATION.CityPlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   matInput type="text" name="city"
                   formControlName="city">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="25%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.ProvincePlaceHolder' | transloco}}</mat-label>
            <input placeholder='{{"REGISTRATION.ProvincePlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   matInput type="text" name="province"
                   formControlName="location">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="14%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.ZipCodePlaceHolder' | transloco}}</mat-label>
            <input maxlength="12" placeholder='{{"REGISTRATION.ZipCodePlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   matInput type="text"
                   name="zipCode" formControlName="zipCode">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="30%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.CountryPlaceHolder' | transloco}}</mat-label>
            <input placeholder='{{"REGISTRATION.CountryPlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   matInput type="text" maxlength="60"
                   formControlName="countryCode" name="countryCode">
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20">
        <div fxLayout="column" [fxFlex]="showCarrier() ? '32%' : '49%'">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.VatNumberPlaceHolder' | transloco}} {{addressCreateUpdateForm.controls.addressType.value === 'I' ? '*' : ''}}</mat-label>
            <input placeholder='{{"REGISTRATION.VatNumberPlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   matInput type="text" maxlength="20"
                   formControlName="vat" name="vat" >
          </mat-form-field>
        </div>
        <div fxLayout="column" [fxFlex]="showCarrier() ? '32%' : '49%'">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.PhonePlaceHolder' | transloco}}</mat-label>
            <input placeholder='{{"REGISTRATION.PhonePlaceHolder" | transloco}}'
                   [readonly]="allowEditCarrierForShipping()"
                   maxlength="30" matInput type="text"
                   name="phone" formControlName="phone">
          </mat-form-field>
        </div>
        <div fxLayout="column" fxFlex="32%" *ngIf="showCarrier()">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.CarrierPlaceHolder' | transloco}}</mat-label>
            <input placeholder='{{"REGISTRATION.CarrierPlaceHolder" | transloco}}'
                   [readonly]="!allowEditCarrier() && allowEditCarrierForShipping"
                   maxlength="30" matInput type="text"
                   name="carrierName" formControlName="carrierName">
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20">
        <div fxLayout="column" fxFlex="100%">
          <mat-form-field>
            <mat-label>{{'REGISTRATION.NotesPlaceHolder' | transloco}}</mat-label>
            <textarea fxFlex=100% matInput formControlName="notes"
                      [readonly]="allowEditCarrierForShipping()"
                      rows="3"
                      placeholder="{{ 'REGISTRATION.NotesPlaceHolder' | transloco}}"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="20" *ngIf="currentUser.role === 'SA' || currentUser.userGroup === 'ED'">
        <div fxLayout="column" [fxFlex]="'49%'">
          <mat-checkbox formControlName="blockPhases1" fxFlex [disabled]="allowEditCarrierForShipping()">
            <span style="white-space: normal">{{'REGISTRATION.blockPhases1' | transloco}}</span>
          </mat-checkbox>
        </div>
        <div fxLayout="column" [fxFlex]="'49%'">
          <mat-checkbox formControlName="blockNextPhases" fxFlex [disabled]="allowEditCarrierForShipping()">
            <span style="white-space: normal">{{'REGISTRATION.blockNextPhases' | transloco}}</span>
          </mat-checkbox>
        </div>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <button mat-raised-button class="btn-default" (click)="unlockGoogleMaps()" *ngIf="allowUnlockGoogleMaps()" [disabled]="unlockedGoogleMaps">
        {{ 'COMMON.UnlockGoogleMaps' | transloco}}
      </button>
      <div fxLayout="row" fxLayoutAlign="flex-end center"[ngStyle]="{'width': allowUnlockGoogleMaps() ? 'auto' : '100%'}">
        <button mat-raised-button color="warn" (click)="closeCreateUpdateModal()">
          {{'COMMON.CancelButton' | transloco}}
        </button>
        <button mat-raised-button class="btn-default" (click)="createUpdateAddress()">
          {{ 'COMMON.SaveButton' | transloco}}
        </button>
      </div>
    </div>
  </mat-card-actions>
</ng-template>
<ng-template #deleteRowConfirmation>
  <mat-card-content fxLayout="column" fxLayoutAlign="center center">
      <span *ngIf="isAbleToBeDeleted">
        {{'users.confirmDeleteMessage' | transloco}}
      </span>
    <span *ngIf="!isAbleToBeDeleted">
        {{'users.notAbleToBeDeleted' | transloco}}
      </span>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="row" style="padding-top:25px;" fxLayoutGap="16px" fxLayoutAlign="center center ">
      <button mat-raised-button color="warn" (click)="closeDeleteModal()">
        {{ (isAbleToBeDeleted ? 'COMMON.CancelButton' : 'COMMON.UndoButton') | transloco}}
      </button>
      <button mat-raised-button class="btn-default" (click)="deleteRow()">
        {{ (isAbleToBeDeleted ? 'COMMON.ConfirmButton' : 'COMMON.HideAddress') | transloco}}
      </button>
    </div>
  </mat-card-actions>
</ng-template>
<ng-template #editRowConfirmationRef>
  <mat-card-content fxLayout="column" fxLayoutAlign="center center">
      <span>
        {{'users.editConfirmMessage' | transloco}}
      </span>
  </mat-card-content>
  <mat-card-actions>
    <div fxLayout="row" style="padding-top:25px;" fxLayoutGap="16px" fxLayoutAlign="center center ">
      <button mat-raised-button color="warn" (click)="closeInformModal()">
        {{'COMMON.UndoButton' | transloco}}
      </button>
      <button mat-raised-button class="btn-default" (click)="addAddressProp(createUpdateRow)">
        {{ 'COMMON.CreateNewAddress' | transloco}}
      </button>
      <button mat-raised-button class="btn-default" *ngIf="allowEditAnyway()" (click)="updateAnyway()">
        {{ 'COMMON.UpdateAnyway' | transloco}}
      </button>
    </div>
  </mat-card-actions>
</ng-template>
